import { render } from "./Home.vue?vue&type=template&id=2598db13&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2598db13"

export default script